
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 31 31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.152 3.892a1.028 1.028 0 00-.326-.74 1.072 1.072 0 00-.767-.295H13.565C13.095 1.253 11.582.066 9.799.066S6.5 1.254 6.03 2.856H1.237a1.092 1.092 0 00-.766.302 1.046 1.046 0 00-.32.745 1.027 1.027 0 00.32.745 1.073 1.073 0 00.766.302H6.03c.471 1.602 1.985 2.79 3.768 2.79 1.783 0 3.297-1.187 3.768-2.79h15.493a1.092 1.092 0 00.775-.303 1.045 1.045 0 00.318-.755zm0 11.163a1.029 1.029 0 00-.326-.74 1.073 1.073 0 00-.767-.296h-4.793c-.47-1.603-1.984-2.79-3.767-2.79s-3.297 1.188-3.768 2.79H1.237a1.091 1.091 0 00-.766.302 1.046 1.046 0 00-.32.745 1.027 1.027 0 00.32.745 1.074 1.074 0 00.766.301h15.494c.471 1.603 1.985 2.791 3.768 2.791 1.783 0 3.297-1.188 3.767-2.79h4.793a1.092 1.092 0 00.775-.303 1.045 1.045 0 00.318-.755zm0 11.163a1.028 1.028 0 00-.326-.74 1.072 1.072 0 00-.767-.296H13.565c-.47-1.603-1.984-2.79-3.767-2.79S6.5 23.579 6.03 25.181H1.237a1.091 1.091 0 00-.766.301 1.046 1.046 0 00-.32.746 1.026 1.026 0 00.32.745 1.072 1.072 0 00.766.301H6.03c.471 1.603 1.985 2.79 3.768 2.79 1.783 0 3.297-1.187 3.768-2.79h15.493a1.092 1.092 0 00.775-.302 1.045 1.045 0 00.318-.755zm-7.87-11.152c0 .976-.786 1.744-1.783 1.744-.998 0-1.784-.768-1.784-1.744s.786-1.744 1.784-1.744c.997 0 1.783.768 1.783 1.744zm-10.7-11.163c0 .976-.787 1.744-1.784 1.744-.998 0-1.784-.768-1.784-1.744S8.8 2.16 9.798 2.16s1.783.768 1.783 1.744zm0 22.326c0 .975-.786 1.744-1.784 1.744s-1.784-.769-1.784-1.744c0-.976.786-1.744 1.784-1.744s1.783.768 1.783 1.744z","fill":"currentColor"}})])
          )
        }
      }
    